import {
  REQUEST_FETCH_AVAILABLE_CABINS,
  FETCH_AVAILABLE_CABINS_SUCCESS,
  FETCH_AVAILABLE_CABINS_ERROR,
  INITIAL_STATE_AVAILABLE_CABINS,
} from "../../../actions/reservations/changeCabin/fetchAbailableCabins";

const initialState = {
  cabins: [],
  fetching: false,
  message: "",
  error: "",
};

const availableCabinReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_AVAILABLE_CABINS: {
      return {
        ...state,
        cabins: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_AVAILABLE_CABINS: {
      return {
        ...state,
        cabins: [],
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_AVAILABLE_CABINS_SUCCESS: {
      return {
        ...state,
        cabins: action.cabins,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_AVAILABLE_CABINS_ERROR: {
      return {
        ...state,
        cabins: [],
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default availableCabinReducer;
